import { Box } from '@mui/material';

import {
  CustomAutoComplete,
  CustomTextField,
  HorizontalForm,
  renderTwoLineOption,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS } from '../../../common/styles';
import MaterialScopeFilters from '../../components/MaterialScopeFilters';
import {
  CONSUMPTION_FILTER_TEXTS as TEXTS,
  CONSUMPTION_STATUS_OPTIONS,
} from '../constants/consumptionsConstants';
import { toWarehouseOptions } from '../../utils/toWarehouseOptions';
import { getFilterFieldSx } from '../../utils/getFilterFieldSx';

const toolbarSx = {
  px: 2.5,
  py: 1.5,
  gap: 1.25,
  alignItems: 'center',
  flexWrap: { xs: 'wrap', lg: 'nowrap' },
  overflowX: 'visible',
};

/**
 * Toolbar de filtros del listado de consumos en una sola fila.
 * @param {Object} props
 * @param {Object} props.filters Filtros vigentes.
 * @param {Array<Object>} [props.warehouses] Depósitos.
 * @param {Function} props.onFilterChange Recibe el evento de los campos de texto y fecha.
 * @param {Function} props.onSelectChange Recibe el evento de los autocompletar.
 * @param {Object} props.scopeOptions Viviendas y búsqueda de materiales.
 * @returns {JSX.Element}
 */
const ConsumptionsFilters = ({
  filters,
  warehouses = [],
  onFilterChange,
  onSelectChange,
  scopeOptions,
}) => {
  const warehouseOptions = toWarehouseOptions(warehouses);

  return (
    <Box sx={{ backgroundColor: 'background.paper', borderBottom: '1px solid #ccc' }}>
      <HorizontalForm withBorder={false} sx={toolbarSx}>
        <CustomAutoComplete
          label={TEXTS.status}
          name="status"
          value={filters.status}
          options={CONSUMPTION_STATUS_OPTIONS}
          onChange={onSelectChange}
          sx={getFilterFieldSx()}
        />
        <CustomAutoComplete
          label={TEXTS.warehouse}
          name="uuid_warehouse"
          value={filters.uuid_warehouse}
          options={warehouseOptions}
          renderOption={renderTwoLineOption}
          inputPlaceholder={TEXTS.searchWarehouse}
          ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
          onChange={onSelectChange}
          sx={getFilterFieldSx()}
        />
        <CustomTextField
          label={TEXTS.orderNumber}
          name="order_number"
          value={filters.order_number}
          onChange={onFilterChange}
          placeholder={TEXTS.orderNumberPlaceholder}
          sx={getFilterFieldSx()}
        />
        <CustomTextField
          label={TEXTS.dateFrom}
          name="date_from"
          type="date"
          value={filters.date_from}
          onChange={onFilterChange}
          shrinkLabel
          sx={getFilterFieldSx()}
        />
        <CustomTextField
          label={TEXTS.dateTo}
          name="date_to"
          type="date"
          value={filters.date_to}
          onChange={onFilterChange}
          shrinkLabel
          sx={getFilterFieldSx()}
        />
        <MaterialScopeFilters
          options={scopeOptions}
          filters={filters}
          onChange={onSelectChange}
          fields={['project', 'article', 'destination']}
          fieldSx={getFilterFieldSx(1.5, 170)}
        />
      </HorizontalForm>
    </Box>
  );
};

export default ConsumptionsFilters;
